import React from "react";
import {useHeader, useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import TransfersByAgentPage from "../modules/TransfersByAgent/TransfersByAgent";
import {useParams} from 'react-router-dom';

export function TransfersByAgent() {
  const {agentId} = useParams();
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "transfersByAgent-page-title",
    defaultMessage: `Agent ${agentId} transfers`
  }, {agentId}));

  const subheader = useSubheader();
  subheader.setDisplaySubheader(false);

  return <TransfersByAgentPage/>;
}
